<div class="field-container" [formGroup]="group">
  <label class="field-label" [for]="config.name">{{ config.label }}</label>
  <div class="field-row">
    <ng-container *ngIf="formConfig.showIcons">
      <div class="icon-container">
        <mat-icon
          fontSet="material-icons-outlined"
          [attr.aria-label]="config.label"
          aria-hidden="false"
        >
          {{ config.icon }}
        </mat-icon>
      </div>
    </ng-container>
    <select
      [id]="config.name"
      [name]="config.name"
      [formControlName]="config.name"
      [required]="config.required"
    >
      <option
        *ngFor="let option of config.fieldConfig.options"
        [value]="option[config.fieldConfig.optionValue]"
      >
        {{ option[config.fieldConfig.optionName] }}
      </option>
    </select>
  </div>
  <ng-container *ngIf="formControl?.errors; else padding">
    <span
      class="error-container"
      [ngStyle]="{ visibility: formControl.touched ? 'inherit' : 'hidden' }"
    >
      {{ formControl?.errors | formError }}
    </span>
  </ng-container>
  <ng-template #padding>
    <span class="error-padding"></span>
  </ng-template>
</div>
